export default __webpack_public_path__ + "static/media/inline.3f49cdb7.svg";